"use strict";

module.exports = require("./is-implemented")() ? Array.prototype.concat : require("./shim");
